import localizeExhibitor from "tools/show/localMap/localization/localizeExhibitor";
import localizeShow from "tools/show/localMap/localization/localizeShow";
import localizeStand from "tools/show/localMap/localization/localizeStand";
import localizePostCode from "tools/show/localMap/localization/localizePostCode";
import { localizeOrganiser } from "tools/show/localMap/localization/localizeOrganiser";

import { IBuildType, IResolvedLocalMap, IShow } from "@evennt-tech/api-v2-core";
import { UseTranslateResult } from "@tolgee/react";
import localizeStandWallLength from "./localization/localizeStandWallLength";

export type LocalMapShow = Pick<IShow, "localMap"> | null | undefined;
export type LocalMapBuildType =
  | Pick<
      IBuildType,
      | "showLocalMap"
      | "standLocalMap"
      | "exhibitorLocalMap"
      | "organiserLocalMap"
    >
  | undefined;

const getLocalMap = (
  show: LocalMapShow,
  buildType: LocalMapBuildType,
  t: UseTranslateResult["t"]
): IResolvedLocalMap => {
  return {
    exhibitor: localizeExhibitor(show, buildType, t),
    show: localizeShow(show, buildType, t),
    stand: localizeStand(show, buildType, t),
    postCode: localizePostCode(show, t),
    standWallLength: localizeStandWallLength(show, t),
    organiser: localizeOrganiser(show, buildType, t),
  };
};

export default getLocalMap;
